import { render, staticRenderFns } from "./CasoView.vue?vue&type=template&id=14841ae8"
import script from "./CasoView.vue?vue&type=script&lang=js"
export * from "./CasoView.vue?vue&type=script&lang=js"
import style0 from "./CasoView.vue?vue&type=style&index=0&id=14841ae8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports